export default __webpack_public_path__ + "static/classic-resume-c50127d5cde396e2a56de5e7a2fcfa86.png";